import { render, staticRenderFns } from "./downloadCode.vue?vue&type=template&id=790164cf&scoped=true"
import script from "./downloadCode.vue?vue&type=script&lang=js"
export * from "./downloadCode.vue?vue&type=script&lang=js"
import style0 from "./downloadCode.vue?vue&type=style&index=0&id=790164cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790164cf",
  null
  
)

export default component.exports